import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-beige border-t border-beige-dark" data-id="element-115">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="mb-12" data-id="element-117">
          <CountdownTimer data-id="element-118" />
        </div>

        <PricingSection data-id="element-119" />

        <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-sm font-medium text-gray-600" data-id="element-120">
          <div className="flex items-center gap-2" data-id="element-121">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-122" />
            <span data-id="element-123">Mercado Pago</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-124">
            <Lock className="w-5 h-5 text-gold" data-id="element-125" />
            <span data-id="element-126">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-127">
            <Shield className="w-5 h-5 text-gold" data-id="element-128" />
            <span data-id="element-129">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}